export class tFormModel {
  formID: number;
  originalFormName: string;
  formName: string;
}

export class FIND_tFormID {
  public static tBed: number = 1;
  public static tShop: number = 2;
  public static tShopBldg: number = 3;
  public static tBookAux: number = 4;
  public static tPatientType: number = 5;
  public static tPatient: number = 6;
  public static tEmployee: number = 7;
  public static tMedicine: number = 8;
  public static tVendor: number = 9;
  public static Booking: number = 10;
  public static tChangeAcct: number = 11;
  public static tItem: number = 12;
  public static tItemCate: number = 13;
  public static tPackage: number = 14;

  public static tPayment: number = 15;
  public static tPricebook: number = 16;

  public static tConsultHead_Waiting: number = 17;
  public static tBookingArrive: number = 18;

  public static outstanding: number = 19;

  public static billpayWalkIn: number = 20;

  public static voidVoucher: number = 21;
  public static patientHistory: number = 22;

  public static tGRN: number = 23;
  // public static stockManagement:number = 24;
  public static inbound: number = 24;

  public static changePay: number = 25;

  public static outbound: number = 26;

  public static tPrescription: number = 27;
  public static PrescriptionList: number = 28;

  public static loginUser: number = 29;

  public static billpay: number = 31;

  public static voidVoucherBackDay: number = 32;

  public static rolePermission: number = 33;

  public static warehouse: number = 34;

  public static accCurrencyMaster: number = 35;

  public static ChartAccMonthEndPosting: number = 36;

  public static AccPostingSetup: number = 37;

  public static ReportControl: number = 38;

  public static EmployeeLeaveControl: number = 39;
  public static LoginManagement = 40;
  public static CustomMasterReport: number = 41;

  public static accRateMaster: number = 42;

  public static accChartAccMaster: number = 43;
  public static accGLSetting: number = 44;
  public static accPeriod: number = 45;
  public static accMonthEndClosing: number = 46;

  public static journal: number = 47;
  public static analysisMaster: number = 48;
  public static yearEnd: number = 49;
  public static questionnaire: number = 50;

  public static PrescriptionPickList: number = 71;
  public static Xray: number = 72;
  public static Physio: number = 73;
  public static copyPrescription: number = 74;
  public static mediTypeMaster: number = 60;
  public static batchNumberEnquiry: number = 61;
  public static tPurchaseOrder: number = 62;
  public static historyByDate: number = 63;
  public static dishesMaster: number = 64;
  public static materialCatMaster: number = 65;
  public static materialMaster: number = 66;
  public static materialList: number = 67;
  public static dishesPlan: number = 68;
  public static OnConsultDiagnosis: number = 1001;
  public static OnConsultAssignItem: number = 1005;
  public static OnConsultAssignTherapist: number = 1006;
  public static OnConsultBillPay: number = 1003;
  public static OnVoidPayment: number = 1004;

  public static OnConsultAssignStartEndTime: number = 1005;
  public static OnConsultAssignQty: number = 1006;
  public static OnConsultServiceItem: number = 1008;
  public static fileUpload: number = 1041;
  public static fileDownload: number = 1042;
  public static Function_AllChangeBillReport: number = 1043;

  public static completeButton_Physio: number = 1045;
  public static completeButton_XRay: number = 1046;
  public static onConsult_payment: number = 1047;
  public static billingActPrice: number = 1048;

  public static onConsult_Physio: number = 1049;

  public static onConsult_XRay: number = 1050;

  /**
   * variable name prefix: %pageName_%desc1_%desc2_%desc3
   * eg1. billing_print_item_checkbox
   * eg2. onConsult_change_treating_dr_menu
   */
  public static functions = {
    billing_print_item_checkbox: 1044,
    visit_consultation:1051
  };

  //Reports
  public static DayendReport: number = 10001;
  public static DayendDetailsReport: number = 10002;

  public static AnalysisReport: number = 10003;

  public static EmployeeServiceReport: number = 10004;
  public static ChangeAccountReport: number = 10005;

  public static StockMovementReport: number = 10006;
  public static PackageRemainderReport: number = 10007;
  public static StockOnHandReport: number = 10008;
  public static BookingReport: number = 10009;

  public static VoidBillReport: number = 10010;
  public static MonthSalesReport: number = 10011;
  public static SalesSummaryByDayReport: number = 10012;

  public static PatientSourceReport: number = 10013;
  public static ConsultAssignRecords: number = 10014;
  public static PatientRecordsReport: number = 10015;
  public static EmployeeServiceReport2: number = 10016;
  public static CustomPatientReport: number = 10017;
  public static GeneralLedgerReport: number = 10018;
  public static TrialBalanceReport: number = 10019;
  public static ProfitAndLossReport: number = 10020;
  public static BalanceSheetReport: number = 10021;
  public static PaymentLedgerReport: number = 10022;
  public static MonthSalesReport2: number = 10023;
  public static MonthSalesReportNewCases: number = 10024;
  public static MaterialOrderReport: number = 10030;
  public static VoidBillNumber: number = 100001;
  public static itemCateReport: number = 10031;
  public static CustomSupplierReport: number = 10032;
  public static MonthSalesAnalysisReport: number = 10033;
  public static DrugSpendingReport:number=10034;
  public static GRNReport: number = 10035;
  public static ImportExportMaster: number = 70;

  public static Debug: number = 888888;
}
